/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1703
 */

require(/* 86 */"../1650/86/index")({
  target: "Reflect",
  stat: true
}, {
  ownKeys: require(/* 1080 */"./1080")
})
